import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import store from "./redux/Store";
import {Provider} from 'react-redux'
import {persistor} from './redux/Store'
import {PersistGate} from 'redux-persist/lib/integration/react';
import App from "./App"
import {SnackbarProvider} from 'notistack'

const POSITION = {
	vertical: 'top',
	horizontal: 'center'
};

ReactDOM.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<SnackbarProvider  anchorOrigin={POSITION}>
				<App/>
			</SnackbarProvider>
		</PersistGate>
	</Provider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();